import styled from 'styled-components';
import { Anchor } from '@klaviyo-mkt/gatsby-components/atoms/anchor';
import { Author } from '@klaviyo-mkt/gatsby-components/organisms/authors';
import { Breadcrumbs } from '@klaviyo-mkt/gatsby-components/molecules/breadcrumbs';
import Typography from '@klaviyo-mkt/gatsby-components/atoms/typography';
import Icon from '@klaviyo-mkt/gatsby-components/atoms/icon';

export const AuthorBreadcrumbs = styled(Breadcrumbs)`
  margin-top: 3.2rem;
  margin-bottom: 3rem;
`;

export const AuthorName = styled(Typography)`
  margin-bottom: 1.2rem;
`;

export const AuthorCardListEyebrow = styled.div`
${({ theme }) => `
  ${theme.fonts.sohne.semibold}
  font-size: 1.6rem;
  line-height: 2.4rem;
  ${theme.screenSize.s768.mediaQuery} {
    font-size: 2rem;
  }
`}`;
export const AuthorTitle = styled.span`
  grid-column: span 8;
  margin-right: 0.3rem;
  color: ${({ theme }) => theme.colors.gray90};
  ${({ theme }) => theme.fonts.sohne.regular};
`;

export const AuthorCompany = styled.span`
  ${({ theme }) => theme.fonts.sohne.semibold};
  margin: 0 0.2rem;
`;

export const AuthorJobInfo = styled.div`
  grid-column: span 8;
  display: flex;
  color: ${({ theme }) => theme.colors.gray90};
  line-height: 2rem;
`;

export const StyledAuthor = styled(Author)`
  grid-column: 1 / -1;
  margin-bottom: 4rem;
  margin-top: 2.4rem;
`;

export const UrlAccessibility = styled.span`
  position: absolute;
  width: 1px;
  clip: rect(0 0 0 0);
  overflow: hidden;
  white-space: nowrap; 
`;

export const StyledIcon = styled(Icon)`
  position: relative;
  top: 0.3rem;
  margin-left: 0.4rem;
  fill: ${({ theme }) => theme.colors.gray90};
`;

export const AuthorUrl = styled(Anchor)`
  grid-column: span 8;
  display: flex;
  align-items: center;
  text-decoration: none !important;

  :hover {
    color: ${({ theme }) => theme.colors.ocean};

    ${StyledIcon}{
      fill: ${({ theme }) => theme.colors.ocean};
    }
  }
`;
